module.exports = __webpack_public_path__ + "static/computedfilter-7e36bca9ab98692c6aa12ef29e6992e1.png";